import i18n from '@/plugins/i18n';

export const k8mNodeGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('k8.cpuUsage'),
      header: {
        title: i18n.global.t('k8.cpuUsage'),
        titleIcon: '',
        content: [],
      },
      chartColor: ['#F59600', '#2F91EC', '#85CF6B'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_total_call',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.memoryUsage'),
      header: {
        title: i18n.global.t('k8.memoryUsage'),
        titleIcon: '',
        content: [],
      },
      chartColor: ['#F59600', '#2F91EC', '#85CF6B'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_total_call',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.storageUsage'),
      header: {
        title: i18n.global.t('k8.storageUsage'),
        titleIcon: '',
        content: [],
      },
      chartColor: ['#F59600', '#2F91EC', '#85CF6B'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_total_call',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.podPercent'),
      header: {
        title: i18n.global.t('k8.podPercent'),
        titleIcon: '',
        content: [],
      },
      chartColor: ['#F59600', '#2F91EC', '#85CF6B'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_total_call',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
  ],
};

export const k8mNodeDetailsGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('k8.cores'),
      header: {
        title: i18n.global.t('k8.cores'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699', '#9FA7E6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'k8s_node_v2_cpu_cores_requests,k8s_node_v2_cpu_cores_limits,k8s_node_v2_cpu_cores_usage',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of millicores',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.cpuUsage'),
      header: {
        title: i18n.global.t('k8.cpuUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_cpu_usage',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      unit: '%',
      axisLabels: {
        x: 'Time',
        y: 'Percentage',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      title: i18n.global.t('k8.memory'),
      header: {
        title: i18n.global.t('k8.memory'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699', '#9FA7E6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'k8s_node_v2_memory_requests,k8s_node_v2_memory_limits,k8s_node_v2_memory_usage_bytes',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'MB',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.memoryUsage'),
      header: {
        title: i18n.global.t('k8.memoryUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_memory_usage',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      unit: '%',
      axisLabels: {
        x: 'Time',
        y: 'Percentage',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      title: i18n.global.t('k8.networkThroughput'),
      header: {
        title: i18n.global.t('k8.networkThroughput'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_network_transmit,k8s_node_v2_network_receive',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of packets',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.networkI/O'),
      header: {
        title: i18n.global.t('k8.networkI/O'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_network_read,k8s_node_v2_network_write',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'MB',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.fsThroughput'),
      header: {
        title: i18n.global.t('k8.fsThroughput'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_fs_reads_total,k8s_node_v2_fs_writes_total',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Count',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('k8.fsI/O'),
      header: {
        title: i18n.global.t('k8.fsI/O'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
      },
      chartColor: ['#F59600', '#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'k8s_node_v2_fs_write_bytes,k8s_node_v2_fs_read_bytes',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'MB',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
  ],
});
